import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserStateModel } from '../../types';

const initialState: UserStateModel = {
  user: {},
  loginStatus: null,
  validateStatus: null,
  isLogout: null,
  errorMsg: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setProfile(state, action: PayloadAction<any>) {
      let data: UserStateModel = action.payload.data;
      state.user = data.user;
      state.loginStatus = data.loginStatus;
      state.validateStatus = data.validateStatus;
      state.errorMsg = data.errorMsg;
    },

    setLogout(state) {
      state.user = {};
      state.isLogout = true;
      state.loginStatus = false;
      state.validateStatus = false;
      state.errorMsg = '';
    },

    clear(state) {
      state = initialState;
    },
  },
});

export default userSlice;
